import { React, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { device } from '../../constants/devices'; 
import axios from 'axios';
import { AuthContext } from '../../context';
import Loader from '../../components/Loader';
import {isEmailValid} from '../../utils';
import {isPwValid} from '../../utils';
import ph from '../../imgs/okok.jpg';
const Root = styled.div`
    width: 100%;
    min-height: 100vh;
    background-image: url(${ph});
    background-size: 100% 100%;
    padding: 200px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    
`;

const UserInfoContainer = styled.main`
    width: 30%;
    display: flex;
    justify-content: center;
    
background: rgba(255, 255, 255, 0.2);
border-radius: 16px;
box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
backdrop-filter: blur(10px);
-webkit-backdrop-filter: blur(10px);
border: 1px solid rgba(255, 255, 255, 0.3);
`;

const UserInfoForm = styled.form`
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const InputContainer = styled.section`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
`;

const InputLabel = styled.label`
    width: 80px;
    margin: 20px 20px;
`;

const Input = styled.input`
position: absolute
top: 20px
left: 12px
font-size: 16px
color: rgba($dark,.5)
font-weight: 500
transform-origin: 0 0
transform: translate3d(0,0,0)
transition: all .2s ease
pointer-events: none

    @media ${device.tablet} {
        width: 280px;
    };
`;
const Notice = styled.div``;

const ButtonsContainer = styled.section``;

const RegisterButton = styled.button`
    background: #C5D9D9;
    margin: 10px auto;
    border-radius: 8px;
    border: none;
    padding: 20px 20px;

    @media ${device.mobileXS} {
        width: 200px;
    };
    @media ${device.tablet} {
        width: 400px;
    };

    &:hover {
        font-weight: bold;
        color: #fefff8;
    }
`;

const ErrorMessage = styled.div`
    text-align: center;
    color: red;
`;
function myFunction()
{
    alert("Welcome to my website");
}
export default function RegisterPage() {
    const { setUser } = useContext(AuthContext);
    const [name, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmit, setIsSubmit] = useState(false);
    const history = useHistory();

    const handleInputFocus = () => {
        setErrorMessage('');
    };
    const handleSubmitForm = (e) => {
        e.preventDefault();
        console.log('hello');
    //     axios.get(`/`)
    //   .then(res => {
    //     console.log('it is get request');
    //   })
    // const data = {
    //     name: username,
    //     password: password,
    //     email: email
    // };
    // const requestOptions = {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify({ name: name,
    //         email: email,
    //         password: password })
    // };
    // fetch('http://localhost:3001/register', requestOptions)
    //     .then(response => response.json())
    //     .then(data => this.setState({ postId: data.id }));
    axios.post('http://localhost:3001/register', {
        name: name,
        email: email,
        password: password,
      }).then(()=>{
        console.log("Succcees");
      });

      if (isSubmit || errorMessage) return ;
      if (!isEmailValid(email)) return setErrorMessage('Invalid email.');
      if (name[0] === ' ' || password[0] === ' ') return setErrorMessage('Please do not type space.');
      if (!name || !password) return setErrorMessage('You must fill in all fields.');
      if (!isPwValid(password)) return setErrorMessage('Password must be at least 8 characters long.');
      if (password !== confirmPassword) return setErrorMessage('Password confirmation went wrong. Please try again.');
//         axios.post(`http://localhost:3001/register`, data)
//         .then(res => {
// console.log ('hello post')
//         })
//         .catch((err)=> {
//             console.log('test error', err);
//         })
        
        // if (isSubmit || errorMessage) return;
        // if (!isEmailValid(email)) return setErrorMessage('Invalid email.');
        // if (username[0] === ' ' || password[0] === ' ') return setErrorMessage('Please do not type space.');
        // if (!username || !password) return setErrorMessage('You must fill in all fields.');
        // if (!isPwValid(password)) return setErrorMessage('Password must be at least 8 characters long.');
        // if (password !== confirmPassword) return setErrorMessage('Password confirmation went wrong. Please try again.');

        // setIsSubmit(true);
        // register(username, email, password)
        // .then((response) => {
        //     if (response.ok !== 1 && response.message === 'ER_DUP_ENTRY') {
        //         setIsSubmit(false);
        //         return setErrorMessage('The username has already existed, please choose another one.');
        //     };
        //     setAuthToken(response.token);
        //     getMe().then((response) => {
        //         if(response.ok !== 1) {
        //             setAuthToken('');
        //             setIsSubmit(false);
        //             return setErrorMessage(response.message);
        //         }
        //         setUser(response.authData.data);
        //         setIsSubmit(false);
        //         history.push('/');
        //     }).catch((err) => {
        //         setIsSubmit(false);
        //         return setErrorMessage(err.message);
        //     });
        // }).catch((err) => {
        //     setIsSubmit(false);
        //     return setErrorMessage(err.message);
        // });
    };

//     const registerUser = () => {
//         const data = {
//             "username": username,
//             "password": password,
//             "email": email
//         }
//         console.log('hello');
//         axios.post(`https://localhost:3001/register`, {
//             username: username,
//             password: password,
//             email: email
//         })
//         .then(res => {
// console.log ('hello')
//         })
//     }
   
    return (
        <Root>
            <UserInfoContainer >
                <UserInfoForm onSubmit={handleSubmitForm}>
                    {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
                    <InputContainer>
                        <InputLabel>Username : </InputLabel>
                        <Input value={name} onChange={e => setUsername(e.target.value)} onFocus={handleInputFocus} placeholder="Username" />
                    </InputContainer>
                    <InputContainer>
                        <InputLabel>Email : </InputLabel>
                        <Input value={email} onChange={e => setEmail(e.target.value)} onFocus={handleInputFocus} placeholder="Email"  />
                    </InputContainer>
                    <InputContainer>
                        <InputLabel>Password : </InputLabel>
                        <Input type="password" value={password} onChange={e => setPassword(e.target.value)} onFocus={handleInputFocus} placeholder="Password"  />
                    </InputContainer>
                    <InputContainer>
                        <InputLabel>Confirm password : </InputLabel>
                        <Input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} onFocus={handleInputFocus} placeholder="Confirm Password" />
                    </InputContainer>
                    <Notice>*Password must be at least 8 characters long.</Notice>
                    <ButtonsContainer>
                        <RegisterButton type="submit" onClick={()=>myFunction()}>Register</RegisterButton>
                    </ButtonsContainer>
                </UserInfoForm>
            </UserInfoContainer>
            {isSubmit && <Loader isLoad={isSubmit}/>}
        </Root>
    )
}